class SiecleLogoIntro extends HTMLElement {
  connectedCallback() {
    this.frames = Array.from(this.querySelectorAll('.siecle-logo-intro__frame'));
    this.skipButton = this.querySelector('.siecle-logo-intro__skip');
    this.designMode = this.dataset.designMode === 'true';
    this.frequency = this.dataset.frequency || 'session';
    this.sessionKey = 'siecle-intro-seen-v2';
    this.timers = [];
    this.finished = false;

    if (!this.frames.length) { this.remove(); return; }
    if (!this.designMode && this.frequency === 'session') {
      try {
        if (window.sessionStorage.getItem(this.sessionKey)) { this.remove(); return; }
      } catch (_) { /* storage may be unavailable; still show intro */ }
    }

    if (this.designMode) {
      this.classList.add('is-preview');
    } else {
      document.documentElement.classList.add('siecle-intro-lock');
      requestAnimationFrame(() => this.classList.add('is-active'));
    }

    const total = Math.max(2500, Math.min(4000, Number(this.dataset.duration) || 3500));
    const step = (total * 0.14); // Four secondary marks progress quickly; main SIÈCLE remains at the end.
    this.showFrame(0);
    for (let i = 1; i < this.frames.length; i++) {
      this.timers.push(window.setTimeout(() => this.showFrame(i), step * i));
    }
    this.timers.push(window.setTimeout(() => this.finish(false), total));
    this.skipButton?.addEventListener('click', () => this.finish(true));
    this._unload = () => this.clearTimers();
    this.addEventListener('shopify:section:unload', this._unload);
  }

  showFrame(index) {
    if (this.finished) return;
    this.frames.forEach((frame, i) => {
      frame.classList.toggle('is-current', i === index);
      if (i === index) frame.setAttribute('aria-hidden', 'false');
      else frame.setAttribute('aria-hidden', 'true');
    });
  }

  clearTimers() {
    (this.timers || []).forEach((timer) => window.clearTimeout(timer));
    this.timers = [];
  }

  finish(skipped) {
    if (this.finished) return;
    this.clearTimers();
    // Leave the brand's main wordmark as the final logo in the customizer preview.
    this.showFrame(this.frames.length - 1);
    this.finished = true;
    if (this.designMode) return;

    this.classList.add('is-finished');
    document.documentElement.classList.remove('siecle-intro-lock');
    if (this.frequency === 'session') {
      try { window.sessionStorage.setItem(this.sessionKey, '1'); } catch (_) { /* ignore */ }
    }
    window.setTimeout(() => this.remove(), 450);
  }

  disconnectedCallback() {
    this.clearTimers();
    document.documentElement.classList.remove('siecle-intro-lock');
  }
}
if (!customElements.get('siecle-logo-intro')) customElements.define('siecle-logo-intro', SiecleLogoIntro);
